import { ApplicationDto } from './ApplicationDto';
import { ApplicationGGDto } from './ApplicationGGDto';

export class ApplicationTransactionDto {
  applicationDto: ApplicationDto | ApplicationGGDto;
  merchantReference: string;
}
